// extracted by mini-css-extract-plugin
export default {"root":"app-react-docker-containers-components-ContainerQuickActions-ContainerQuickActions-module__root"};